/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto } from '../models/Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MoneyEntitlementService {

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiMoneyEntitlementsEnabledMethods(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/money-entitlements/enabled-methods',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiMoneyEntitlementsExistingSetup(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/money-entitlements/existing-setup',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static putApiAwardSettlementApiMoneyEntitlements(
requestBody?: Array<Wealthlane_AwardSettlementService_Dtos_MoneyEntitlementMethodDto>,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award-settlement/api/money-entitlements',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
